import { DatePipe } from '@angular/common';
import {
  Component,
  OnInit,
} from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef } from '@angular/material/dialog';

import {
  combineLatest,
  Subject,
} from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { environment } from '../../../../../../../environments/environment';
import { LocalStorageService } from '../../../../../../core/localStorage/local-storage.service';
import {
  AppUser,
  AuthService,
} from '../../../../../../core/modules/auth/services/auth.service';
import {
  Customer,
  CustomerService,
} from '../../../../../../core/modules/auth/services/customer.service';
import { LicenseState } from '../../../../services/licensing.interfaces';
import { LicensingRenewalDialogComponent } from '../../licensing-renewal-dialog.component';

const RENEW_DIALOG_KEY_30DAYS = 'mute_renew_dialog_30DAYS';
const RENEW_DIALOG_KEY_14DAYS = 'mute_renew_dialog_14DAYS';

@Component({
  selector: 'app-base-licensing-info',
  template: `<p></p>`,
  styles: []
})
export class BaseLicensingInfoComponent implements OnInit {

  public muteNotification: boolean;

  public sourceData: {
    licenseState: LicenseState;
    activeUser: AppUser;
    dialogRef: MatDialogRef<LicensingRenewalDialogComponent>;
  };

  public templateData: {
    domain: string;
    expireDate?: string;
    expireDays?: number;
    expiryMessage?: string;
    showIcon?: boolean;
    showSupportButton?: boolean;
    showRecheckButton?: boolean;
    showRenewalButton?: boolean;
    plan?: string;
    pastDeleteDataWindow?: boolean;
    lastTierExpiration?: {
      type: string;
      date: Date;
    };
  };

  private onDestroy$: Subject<void> = new Subject<void>();
  private user: AppUser;
  private customer: Customer;

  constructor(
    public datePipe: DatePipe,
    public localStorageService: LocalStorageService,
    public authService: AuthService,
    public customerService: CustomerService
  ) {
    combineLatest([
      this.authService.appUser$,
      this.customerService.getCustomer()
    ])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(([user, customer]) => {
        this.user = user;
        this.customer = customer;
      });
  }

  ngOnInit(): void {
    if (this.sourceData.licenseState.expiresIn <= 7) {
      this.muteNotification = false;
    }
  }

  checkMuteStatus(): void{
    if (this.sourceData.licenseState.expiresIn > 7 && this.sourceData.licenseState.expiresIn < 15) {
      this.muteNotification = this.localStorageService.get(RENEW_DIALOG_KEY_14DAYS) === 'true';
    }

    if (this.sourceData.licenseState.expiresIn >= 15 && this.sourceData.licenseState.expiresIn <=30) {
      this.muteNotification = this.localStorageService.get(RENEW_DIALOG_KEY_30DAYS) === 'true';
    }
  }

  requestRenewal(): void {
    const url = environment.urls.external.renew
      .replace('{app_name}', 'Little SIS Premium')
      .replace('{customerId}', this.customer.customerId)
      .replace('{domain}', this.customer.domain)
      .replace('{user_name}', this.user.profile.displayName);

    window.open(url);
  }

  requestSupport(domain: string): void {
    const url = `https://mail.google.com/mail/?view=cm&source=mailto&to=${environment.support.email}&su=Little SIS for Premium license support request for ${domain}.`;
    window.open(url);
  }

  requestTrial(): void{
    const url = environment.urls.external.trialRequest;
    window.open(url);
  }

  openHelpCenter(): void{
    const url = environment.urls.external.helpCenter;
    window.open(url);
  }

  toggleReminder(e: MatCheckboxChange): void {
    if (this.templateData.expireDays > 7 && this.templateData.expireDays < 15) {
      this.localStorageService.set(RENEW_DIALOG_KEY_14DAYS, String(e.checked));
    }

    if (this.templateData.expireDays >= 15 && this.templateData.expireDays <= 30) {
      this.localStorageService.set(RENEW_DIALOG_KEY_30DAYS, String(e.checked));
    }
  }

  logout(): void {
    this.authService.logout(this.sourceData.activeUser.role,true).catch(error => console.error(error));
  }

  closeDialog(): void {
    this.sourceData.dialogRef.close();
  }

  isSuperAdmin(): boolean {
    return this.sourceData.activeUser.role === 'admin';
  }



}
